import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { ObjectTarget } from "../../../app/permissions";
import { getNamedObject, retrieveObject, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { useEffect, useState } from "react";
import BadgedAvatar from "../../../features/base/BadgedAvatar";
import { NamedObject } from "../../../redux/object/namedObject";
import { Stack } from "@mui/material";

interface NamedObjectDisplayProps {
    objectTarget: ObjectTarget;
    targetId?: string;
}

const NamedObjectDisplay = ({ objectTarget, targetId }: NamedObjectDisplayProps) => {
    const dispatch = useAppDispatch();
    const objectCache = useSelector(selectObjectCache);
    const [object, setObject] = useState(undefined as NamedObject | undefined);

    useEffect(() => {
        if(!targetId) {
            setObject(undefined);
            return;
        }
        const named = getNamedObject(objectCache, { objectTarget, targetId });
        if(named) {
            setObject(named);
        } else {
            dispatch( retrieveObject({ objectTarget, targetId }) );
        }
    }, [objectCache, objectTarget, targetId]);

    return <Stack direction="row" spacing={1} alignItems="center">
        { targetId &&
            <BadgedAvatar
                title={object?.display || ""}
                size="32px"
                avatar={object?.thumbnail}
                marginRight={1}
            />
        }
        &nbsp;
        {object?.display || targetId}
    </Stack>;

};

export default NamedObjectDisplay;